<template>
  <!--
    No BlockFieldset at the root: it would also disable the card headers, so readers could not open
    a card. AccordionCard disables only its body.
  -->
  <div class="project-service-report-data">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <template v-else>
      <MobileProjectsServiceReport
        :project="project"
        :saveCard="saveCard"
        :reportTemplateImages="project.reportTemplateImages"
      />
      <ProjectReportVerificationRequest :project="project" :protocol="protocol" />
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MobileProjectsServiceReport from '@/views/Projects/MobileProjectsServiceReport';
import ProjectReportVerificationRequest from '@/blocks/project/report/ProjectReportVerificationRequest';

/** Number of the unsaved project (ProjectEdit `_new`). */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-service-report-data ("Service: Erfasste Daten", see feature page
 * projekt-protokolle): the cards, saved per card with "weiter"/"zurück" and the card state toggle,
 * with their photos; below them the section "12. Prüfung" with the service state and its request
 * button (the block project-service-report-verification requests too). `project` is the block data
 * (`Project.blocks.serviceReportData`) with the reference data of the cards.
 */
export default {
  name: 'ProjectServiceReportData',
  components: { ProjectReportVerificationRequest, MobileProjectsServiceReport },
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
    /** Config of the protocol (`reportProtocols.js`), passed by the tab; not imported here (cycle). */
    protocol: { type: Object, required: true },
  },
  computed: {
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['updateProjectServiceReportData']),
    saveCard(input) {
      return this.updateProjectServiceReportData({ projectNumber: this.project.number, input });
    },
  },
};
</script>
